// 课程属性枚举
export const COURSE_ATTRIBUTE = {
  NAME: 0, // 课程名
  CATAlOG: 1, // 分类
  TIME: 2, // 标准时长
  SCORE: 3, // 学分
  CONTENT_TAG: 4, // 内容标签
  SKILL_TAG: 5, // 能力标签
  DESCRIBE: 6, // 简介
  PRICE: 7, // 价格
  CUSTOM_ATTRIBUTE: 8, // 自定义属性信息
  CONTRIBUTOR: 9, // 贡献者
  AUTHOR: 10, // 作者
  LECTURER: 11, // 主讲老师
  ASSISTANT_LECTURER: 12, // 辅讲老师
  CREATOR: 13, // 上传者
  CUSTOM_RELATED: 14, // 自定义相关方信息
  UNIQUE_CODE: 15, // 课程编号
  ATTACHMENT: 16, // 附件
  VALID_DATE: 17, // 有效期
  STUDY_NUM: 18, // 学习人数
  VIEW_NUM: 19, // 浏览人数
  VIEW_COUNT: 20, // 浏览人次
  CREATE_TIME: 21, // 创建时间
  UPDATE_TIME: 22, // 更新时间
  CUSTOM_CODE: 23 // 自定课程编号
};
